import { useState, useEffect, useContext } from 'react'
import Layout from '../../components/layout'
import { Header, Wrapper, Content, CardContainer } from './style'
import { Footer } from '../../components/Footer'
import { AuthContext } from '../../context/auth'
import { toAbsoluteUrl } from '../../utils/assetHelper'
import { getProductReleaseApi, createCartApi, addItemsToCartApi } from '../../api'
import { useNavigate } from 'react-router-dom'
import { setLocalStorage, getLocalStorage } from '../../helpers/localStorage'
import { useGtag } from '../../hooks/useGtag'

const Index = () => {
const { setIsLoading, setNotification, setCartData, isLoading, setUpcomingPurchaseModal, setBulkOrderModal } = useContext(AuthContext)
const { gtagAddToCart } = useGtag()
const cartId = getLocalStorage('cartId')
const navigate = useNavigate()
const [products, setProducts] = useState({
    primary: [],
    primaryConjugates: [],
    secondary: []
})
  const AddToCart = (selectedProduct) => {
    setIsLoading(true)
    if (!cartId) {
        createCartApi().then(res => {
            setLocalStorage('cartId', res.data.cart.id)
            addItemsToCartApi(res.data.cart.id, {
                variant_id: selectedProduct?.variants[0]?.id,
                quantity: 1,
            }).then((res) => {
                if (res && res.data && res.data?.cart) {
                    setCartData(res.data.cart)
                    setNotification({
                        message: 'Added to cart',
                        type: 'green',
                    })
                    gtagAddToCart(res?.data?.cart?.subtotal, selectedProduct)
                    setIsLoading(false)
                } else {
                    setNotification({
                        message: 'Something went wrong',
                        type: 'red',
                    })
                    setIsLoading(false)
                }
            })
        })
    } else {
        addItemsToCartApi(cartId, {
            variant_id: selectedProduct?.variants[0]?.id,
            quantity: 1,
        }).then((res) => {
            if (res && res.data && res.data?.cart) {
                setCartData(res.data.cart)
                setNotification({
                    message: 'Added to cart',
                    type: 'green',
                })
                gtagAddToCart(res?.data?.cart?.subtotal, selectedProduct)
                setIsLoading(false)
            } else {
                setNotification({
                    message: 'Something went wrong',
                    type: 'red',
                })
                setIsLoading(false)
            }
        })
    }
}

const getProducts = async () => {
    try {
        getProductReleaseApi().then(res => {
            if (res && res.data) {
                const primary = res?.data?.products?.filter(item => !['DC', 'SA'].includes(item?.mid_code))
                const primaryConjugates = res?.data?.products?.filter(item => item?.mid_code === 'DC')
                const secondary = res?.data?.products?.filter(item => item?.mid_code === 'SA')
                setProducts({
                    primary,
                    primaryConjugates,
                    secondary
                })
            }
        })
    } catch (error) {
        console.log(error)
    }
}

useEffect(() => {
    getProducts()
}, [])

    return (
        <Layout>
            <Wrapper>
                <div className="container title-container">
                    <span style={{ width: '44px', height: '44px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '12px', background: '#fff2e5', color: 'var(--primary-color)' }}>
                        <img src={toAbsoluteUrl("/media/antibody.png")} alt="" style={{ width: '20px' }} />
                    </span>
                    <Header>
                        <h1>Identifyn® New Product Release Availability</h1>
                    </Header>
                </div>
                <Content>
                    <CardContainer gap={'24px'} textAlignP={'left'}>
                        <h3>Exciting news! For a limited time, you can get the latest Identifyn® products directly from us as soon as they launch. Don't miss out on the opportunity to be among the first to be empowered with these superior reagents!</h3>
                        <p>Identifyn® rigorously tested reagents, spanning from Widefield to Super-resolution and Single Molecule Microscopy, Multiplex and Flow Cytometry are designed for maximum sensitivity, specificity and superior brightness.With our unique conjugation chemistry and Super Resolution vetting, you’re ensured bright, specific and reproducible results for your research. Explore these innovative solutions now available for a limited time via our new e-commerce platform! **</p>
                        <p><strong>Bulk Order</strong> - Identifyn® Reagents are now ready for bulk orders, accommodating whatever your volume needs are! Additionally, we offer custom super resolution data sets tailored just for you! Explore the possibilities today!</p>
                        <button className='btn bulk-btn' onClick={() => setBulkOrderModal(true)}>Bulk Order</button>
                    </CardContainer>
                    {!!products?.primary?.length  && 
                    <CardContainer gap={'24px'} textAlignP={'left'} flexDirection={'row'} justifyContent={'space-between'}>
                       <h2>Primary Antibodies</h2>
                       {products?.primary?.map((item, index) => {
                           return (
                               <div className="product" key={index}>
                                   <div className='product-details'>
                                       <h4><strong>{item.mid_code}-{item.material}</strong></h4>
                                       <h4>{item.title}</h4>
                                       <h4>${(item.variants && item?.variants[0]?.prices[0]?.amount / 100 )?.toFixed(2)}</h4>
                                   </div>
                                   <div className="btn-container">
                                       <button className='btn transparent view-btn'
                                       onClick={() => navigate(`/product-search/${item.handle}`)}
                                       >View Product</button>
                                       <button className='btn add-btn' 
                                        onClick={() => {
                                        if(!isLoading){
                                        AddToCart(item)
                                        }}}
                                       ><i className='fal fa-shopping-cart'></i>Add to Cart</button>
                                   </div>
                               </div>
                           )
                       })}
                    </CardContainer>
                    }
                    {!!products?.primaryConjugates?.length  && 
                    <CardContainer gap={'24px'} textAlignP={'left'} flexDirection={'row'} justifyContent={'space-between'} background={'#fff2e5'}>
                       <h2>Primary Direct Conjugates</h2>
                       {products?.primaryConjugates?.map((item, index) => {
                           return (
                               <div className="product" key={index}>
                                   <div className='product-details'>
                                       <h4><strong>{item.mid_code}-{item.material}</strong></h4>
                                       <h4>{item.title}</h4>
                                        <h4>${(item.variants && item?.variants[0]?.prices[0]?.amount / 100 )?.toFixed(2)}</h4>
                                   </div>
                                   <div className="btn-container">
                                       <button className='btn transparent view-btn'
                                       onClick={() => navigate(`/product-search/${item.handle}`)}
                                       >View Product</button>
                                       <button className='btn add-btn' 
                                        onClick={() => {
                                        if(!isLoading){
                                        AddToCart(item)
                                        }}}
                                       ><i className='fal fa-shopping-cart'></i>Add to Cart</button>                                                                           
                                   </div>
                               </div>
                           )
                       })}
                    </CardContainer>
                    }
                    {!!products?.secondary?.length  && 
                     <CardContainer gap={'24px'} textAlignP={'left'} flexDirection={'row'} justifyContent={'space-between'} background={'#f1eefc'}>
                       <h2>Secondary Fluorescent Antibodies</h2>
                       {products?.secondary?.map((item, index) => {
                           return (
                               <div className="product" key={index}>
                                   <div className='product-details'>
                                       <h4><strong>{item.mid_code}-{item.material}</strong></h4>
                                       <h4>{item.title}</h4>
                                        <h4>${(item.variants && item?.variants[0]?.prices[0]?.amount / 100 )?.toFixed(2)}</h4>                                       
                                   </div>
                                   <div className="btn-container">
                                       <button className='btn transparent view-btn'
                                       onClick={() => navigate(`/product-search/${item.handle}`)}
                                       >View Product</button>
                                       <button className='btn add-btn' 
                                        onClick={() => {
                                        if(!isLoading){
                                        AddToCart(item)
                                        }}}
                                       ><i className='fal fa-shopping-cart'></i>Add to Cart</button>
                                   </div>
                               </div>
                           )
                       })}
                    </CardContainer>
                    }
                    <CardContainer gap={'24px'} textAlignP={'left'}>
                        <h3>Product Availability Disclaimer</h3>
                        <p><em>** For a limited period of time, Identifyn® new release products are available directly from Identifyn® in the United States markets only. At such time as we transfer the product to our partner ThermoFisher™, these products will no longer be available via Identifyn® but exclusively through ThermoFisher™.</em></p>
                        <a href="https://www.thermofisher.com/" target="_blank"><img src={toAbsoluteUrl("/media/thermologo.png")} alt="thermologo" /></a>
                    </CardContainer>
                </Content>
            </Wrapper>
            <Footer />
        </Layout>
    )
}

export default Index